module.exports = __webpack_public_path__ + "static/img/error.08d8849.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/error.png
// module id = 76Xz
// module chunks = 1